import './SpecialDayOffInfoTab.scss';
import { useTranslation } from 'react-i18next';
import CountdownTimer from '../CountdownTimer/CountdownTimer';
import { useSpecialDayOffProvider } from '../../providers/SpecialDayOffProvider';
import { getEasternTime } from '../../helpers/dateHelpers';
import { datesFirstCaps } from '../../constants/dates';
import {
  infoTabStatus,
  getMonthNday,
  getHourNminute,
  sdoStatusType
} from './SpecialDayOffHelper';
import Loader from '../Loader/Loader';
import { NavLink } from 'react-router-dom';

export default function SpecialDayOffInfoTab() {
  const { t } = useTranslation();
  const specialDayOffContext = useSpecialDayOffProvider();
  const today = getEasternTime();
  const startDay = specialDayOffContext.sdoInfoTabData?.submissionFromDt;
  const endDay = specialDayOffContext.sdoInfoTabData?.submissionToDt;
  const replyDay = specialDayOffContext.sdoInfoTabData?.submissionReplyDt;
  const exemption =
    specialDayOffContext.sdoInfoTabData?.exemptionFlag?.toLocaleLowerCase() ||
    'n';
  const training =
    specialDayOffContext.sdoCalendarData?.trainingFlag?.toLocaleLowerCase() ||
    'n';
  const totalApprovedSDOs = specialDayOffContext.sdoMyRequestData?.filter(sdo => 
    sdo.sdoYear === specialDayOffContext.sdoInfoTabData.sdoYear && 
    sdo.status === sdoStatusType.APPROVED
  ).length || 0;
  const tabStatus = totalApprovedSDOs >= 2 ? sdoStatusType.APPROVED : '';
  const sdoMonth =
    datesFirstCaps[+specialDayOffContext.sdoInfoTabData?.sdoMonth - 1] || '';
  const sdoYear = specialDayOffContext.sdoInfoTabData?.sdoYear || '';
  const responseDelayFlag =
    specialDayOffContext.sdoInfoTabData?.responseDelayFlag?.toLocaleLowerCase() ||
    'n';

  const infoTabContent = {
    status: '',
    statusClass: '',
    statusDesc: '',
    time: ''
  };

  const getInfoTabContent = () => {
    switch (true) {
      case training && training === 'y':
        infoTabContent.status = infoTabStatus.closed;
        infoTabContent.statusClass = 'sdo-info-tab__closed';
        infoTabContent.statusDesc = t(
          'specialDayOff.infoTab.nextSubmissionPeriod'
        );
        infoTabContent.time = 'After Training';
        break;
      // approved and no exemption and within submission period
      case tabStatus === sdoStatusType.APPROVED &&
        exemption === 'n' &&
        startDay <= today &&
        today <= endDay:
        infoTabContent.status = infoTabStatus.open;
        infoTabContent.statusClass = 'sdo-info-tab__open';
        infoTabContent.statusDesc = t('specialDayOff.infoTab.timeLeftToSubmit');
        infoTabContent.time = 'timer';
        break;
      // approved and no exemption and sdoYear is next year and sdoMonth should be Jan
      case tabStatus === sdoStatusType.APPROVED &&
        exemption === 'n' :
        // specialDayOffContext.sdoInfoTabData?.sdoYear >
        //   specialDayOffContext.sdoMyRequestData[0]?.sdoYear &&
        // specialDayOffContext.sdoInfoTabData?.sdoMonth === '1':
        infoTabContent.status = infoTabStatus.approved;
        infoTabContent.statusClass = 'sdo-info-tab__approved';
        infoTabContent.statusDesc = t('specialDayOff.infoTab.nextSDOcycle');
        infoTabContent.time = `${sdoMonth} ${sdoYear}`;
        break;
      // approved and with exemption and within submission period
      case tabStatus === sdoStatusType.APPROVED &&
        exemption === 'y' &&
        startDay <= today &&
        today <= endDay:
        infoTabContent.status = infoTabStatus.open;
        infoTabContent.statusClass = 'sdo-info-tab__open';
        infoTabContent.statusDesc = t('specialDayOff.infoTab.timeLeftToSubmit');
        infoTabContent.time = 'timer';
        break;
      case startDay <= today && today <= endDay && responseDelayFlag === 'y':
        // the condition tabStatus.includes('approved') && exemption === 'y' comes here
        infoTabContent.status = infoTabStatus.openSoon;
        infoTabContent.statusClass = 'sdo-info-tab__soon';
        infoTabContent.statusDesc = t(
          'specialDayOff.infoTab.nextSubmissionPeriod'
        );
        infoTabContent.time = `${sdoMonth} ${sdoYear}`;
        break;
      case startDay <= today && today <= endDay:
        // the condition tabStatus.includes('approved') && exemption === 'y' comes here
        infoTabContent.status = infoTabStatus.open;
        infoTabContent.statusClass = 'sdo-info-tab__open';
        infoTabContent.statusDesc = t('specialDayOff.infoTab.timeLeftToSubmit');
        infoTabContent.time = 'timer';
        break;
      case startDay > today || today > endDay:
        // the condition tabStatus.includes('approved') && exemption === 'y' comes here
        infoTabContent.status = infoTabStatus.openSoon;
        infoTabContent.statusClass = 'sdo-info-tab__soon';
        infoTabContent.statusDesc = t(
          'specialDayOff.infoTab.nextSubmissionPeriod'
        );
        infoTabContent.time = `${sdoMonth} ${sdoYear}`;
        break;
      default:
        infoTabContent.status = '';
        infoTabContent.statusClass = '';
        infoTabContent.statusDesc = t(
          'specialDayOff.infoTab.nextSubmissionPeriod'
        );
        infoTabContent.time = '';
        break;
    }
  };

  if (
    !specialDayOffContext.sdoInfoTabLoading &&
    !specialDayOffContext.sdoMyRequestLoading
  ) {
    getInfoTabContent();
  }

  return specialDayOffContext.sdoInfoTabLoading ||
    specialDayOffContext.sdoMyRequestLoading ? (
    <Loader />
  ) : (
    <div className="sdo-info-tab__container">
      {/* {(specialDayOffContext.sdoInfoTabLoading || specialDayOffContext.sdoMyRequestLoading) ? '' : <> */}
      {responseDelayFlag === 'y' ? (
        <div className="sdo-info-tab__notification-delay">
          <i className="icon-circle-flight" />
          <p>{t('specialDayOff.infoTab.delayMessage')}</p>
        </div>
      ) : (
        ''
      )}

      {training && training === 'y' ? (
        <div className="sdo-info-tab__grid-container--training">
          <div className="sdo-info-tab__timer">
            <div
              className={`sdo-info-tab__status ${infoTabContent.statusClass}`}
            >
              {infoTabContent.status}
            </div>
            <p className="sdo-info-tab__info">{infoTabContent.statusDesc}:</p>
            {infoTabContent.time === 'timer' ? (
              <CountdownTimer
                biddingClosedWithTime={endDay}
                sdoAdminReport={false}
              />
            ) : (
              <span className="sdo-info-tab__timer__next-cycle">
                {infoTabContent.time}
              </span>
            )}
          </div>
          <div className="sdo-info-tab__grid-pdf-info">
            <p className="sdo-info-tab__desc">
              {t('specialDayOff.infoTab.infoDescription')}
              <NavLink to="/faqs#sdo">
                {t('specialDayOff.infoTab.infoLearnMore')}
              </NavLink>
            </p>
          </div>
        </div>
      ) : (
        <div className="sdo-info-tab__grid-container">
          <div className="sdo-info-tab__timer">
            <div
              className={`sdo-info-tab__status ${infoTabContent.statusClass}`}
            >
              {infoTabContent.status}
            </div>
            <p className="sdo-info-tab__info">{infoTabContent.statusDesc}:</p>
            {infoTabContent.time === 'timer' ? (
              <CountdownTimer
                biddingClosedWithTime={endDay}
                sdoAdminReport={false}
              />
            ) : (
              <span className="sdo-info-tab__timer__next-cycle">
                {infoTabContent.time}
              </span>
            )}
          </div>
          {infoTabContent.status !== infoTabStatus.closed && (
            <>
              <div className="sdo-info-tab__grid-sub-period">
                <div className="sdo-info-tab__grid-sub-period__details">
                  <p className="sdo-info-tab__grid-sub-period__info">
                    {t('specialDayOff.infoTab.submissionPeriod')}:
                  </p>
                  {responseDelayFlag === 'y' ? (
                    <p className="sdo-info-tab__grid-sub-period__info--normal">
                      {t('specialDayOff.infoTab.pendingAward')}
                    </p>
                  ) : (
                    <p className="sdo-info-tab__grid-sub-period__info--normal">
                      {getMonthNday(startDay)} - {getMonthNday(endDay)}{' '}
                      {getHourNminute(endDay)}{' '}
                    </p>
                  )}
                </div>
              </div>
              <div className="sdo-info-tab__grid-result">
                <div className="sdo-info-tab__grid-sub-period__details">
                  <p className="sdo-info-tab__grid-sub-period__info">
                    {t('specialDayOff.infoTab.replyOnRequest')}:
                  </p>
                  <p className="sdo-info-tab__grid-sub-period__info--normal">
                    {getMonthNday(replyDay)} {getHourNminute(replyDay)}{' '}
                  </p>
                </div>
              </div>
            </>
          )}

          <div className="sdo-info-tab__grid-pdf-info">
            <p className="sdo-info-tab__desc">
              {t('specialDayOff.infoTab.infoDescription')}
              <NavLink to="/faqs#sdo">
                {t('specialDayOff.infoTab.infoLearnMore')}
              </NavLink>
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
